<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      visible
      width="600px"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => $refs.main.cancel()"
    >
      <Main
        ref="main"
        :row="row"
        :tableData="tableData"
        @close="close"
        @success="(e) => $emit('success', e)"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' },
    row: { type: Object, default: () => ({}) },
    tableData: { type: Array, default: () => [] },
  },
  computed: {
    titleMap() {
      return {
        add: this.$l('INDEX.btn_add') || '新增',
        edit: this.$l('INDEX.btn_tips_edit') || '编辑',
      }
    },
    title() {
      return this.titleMap[this.type]
    },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
